module.exports = __webpack_public_path__ + "img/Joshua-Bongard-4x.93208026.png";